/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ListQuery } from './listQuery.schema';

export const GetMyMembers = zod.object({
  "payload": zod.lazy(() => ListQuery).optional()
});

export type GetMyMembers = zod.input<typeof GetMyMembers>;
export type GetMyMembersOutput = zod.output<typeof GetMyMembers>;
